import React from 'react';
import { toast } from "react-toastify";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import extensionService from '../../services/extensionService';
import accountService from '../../services/accountService';
import { confirm } from '../common/modals/confirmService';
import organizationService from '../../services/organizationService';
import profileService from '../../services/profileService';
import PageTitle from '../common/PageTitle';
import Extension from './modals/extension';
import { validateE164Number } from '../../utils/utils'
import * as moment from 'moment'


export default class Extensions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            number: '',
            organization: {},
            id: this.props.match.params.organizationId,
            serialNo: null,
            extensions: [],
            extension: {},
            show: false,
            showModalExtension: false,
            editingExtensionId: null,
            editingExtensionName: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleShowModalExtension = this.handleShowModalExtension.bind(this);
        this.handleRemoveExtension = this.handleRemoveExtension.bind(this);
        this.handleDeactivateExtension = this.handleDeactivateExtension.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleExtensionNameChange = this.handleExtensionNameChange.bind(this)
        this.changeExtensionName = this.changeExtensionName.bind(this)
    }

    componentDidMount() {
        this.loadOrganizationById();
    }
    handleClose() {
        this.setState({
            showModalExtension: false
        });
    }

    handleShowModalExtension(extension) {
        this.setState({
            showModalExtension: true,
            extension: extension ? extension : null,
        });
    }

    loadOrganizationById() {
        organizationService.getById(this.state.id).then(result => {
            this.setState({
                organization: result,
                // name: result.name,
                serialNo: result.device ? result.device.serialNo : null,
            })
            if (this.state.serialNo) {
                this.loadExtensions();
                this.loadPendingInvites()
            }

        }).catch(error => {
            toast.error("Error loading organization", this.options)
        });
    }

    loadExtensions() {
        extensionService.getByDevice(this.state.serialNo).then(response => {
            this.setState({
                extensions: response.extensions ? response.extensions : []
            })
        })
    }

    loadPendingInvites() {
        profileService.getOrganizationPendingInvites(this.state.id).then(response => {
            this.setState({
                pending: response || []
            })
        })
    }

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });

    }


    handleSubmit = event => {
        if (validateE164Number(this.state.number)) {
            this.setState({ numberError: null })
            accountService.inviteAccountToOrganization(this.state.organization._id, this.state.number, this.state.serialNo)
                .then(response => {
                    toast.success("User successuffuly added!", this.options);
                    this.loadPendingInvites()
                }).catch(error => {
                })
        } else {
            this.setState({ numberError: 'Phone Number is not a valid E164 number. Proper format is: \n + (Country Code) (Area Code) Number' })
        }
    }

    handleRemoveExtension(extenisonId) {
        confirm('Are you sure you want to remove extension?').then(() => {
            extensionService.deleteExtension(this.state.serialNo, extenisonId).then(response => {
                toast.success("Extensions deleted successuffuly!", this.options);
                this.loadExtensions()
            }).catch(error => {
            })
        }, () => { });
    }

    handleDeactivateExtension(extenisonId) {
        confirm('Are you sure you want to deactivate extension?').then(() => {
            extensionService.deactivate(this.state.serialNo, extenisonId).then(response => {
                toast.success("Extensions deactivated successuffuly!", this.options);
                this.loadExtensions()
            }).catch(error => {
            })
        }, () => { });
    }

    showExtensionStatus(extension) {
        if (!extension.active) {
            return (<td> PENDING </td>)
        } else if (extension.active === 1) {
            return (<td> ACTIVE </td>)
        } else if (extension.active === 2) {
            return (<td> INACTIVE </td>)
        } else {
            return (<td> </td>)
        }
    }

    handleRemoveInvite(inviteId) {
        confirm('Are you sure you want to remove this pending invite?').then(async () => {
            await profileService.removeOrganizationExtensionsInvite(this.state.id, inviteId)
            this.loadPendingInvites()
        }, () => { });

    }

    editExtensionName(extension) {
        this.setState({ editingExtensionName: extension.name, editingExtensionId: extension._id })
    }

    handleExtensionNameChange(event) {
        const { value } = event.target;
        this.setState({ editingExtensionName: value });
    }

    async changeExtensionName() {
        const { editingExtensionId, editingExtensionName } = this.state;
        await extensionService.updateById(editingExtensionId, { name: editingExtensionName })
        this.setState({ editingExtensionName: null, editingExtensionId: null })
        this.loadExtensions()
    }

    render() {
        const { number, organization, id, extensions, showModalExtension, extension, pending, editingExtensionId, editingExtensionName, numberError } = this.state;
        return (
            <div>
                {showModalExtension ? <Extension show={showModalExtension} handleClose={this.handleClose} serialNo={organization.device.serialNo} extension={extension} /> : null}
                <div className="gpc-extension">
                    <Row noGutters className="page-header py-4">
                        <PageTitle title={`${organization.name} members`} subtitle="Manage organization members" className="text-sm-left text-capitalize" />
                    </Row>
                    <Row noGutters className="page-description">
                        <p className="light-grey">
                            This is the page that displays your managed organization accounts, and all associated members forming the extensions for each organization. By inviting chosen contacts to become members to your paid organization, they can make GCP VoIP calls from their AirTouch One app sharing call credits from the subscribed organization service plan.
                 </p>
                    </Row>
                    {/* {organization.device ? */}
                    <div>

                        <Card className="mb-4 card-custom">
                            <CardHeader className="border-bottom card-header-custom">
                                <h6 className="m-0">
                                    <div className="search-box">
                                        <label htmlFor="">Invite user to join organization {organization.name}</label>
                                        <div className="">
                                            <div className="form-organization">
                                                <div className="custom-form-inline">
                                                    <input id='number'
                                                        className="form-control bordered"
                                                        type="text" name="number"
                                                        value={number}
                                                        placeholder=" + country code and mobile number"
                                                        onChange={this.handleChange} />
                                                    <button className="btn lightblue pull-right bt-w-95"
                                                        onClick={this.handleSubmit}>Invite</button>
                                                </div>

                                            </div>
                                            {numberError &&
                                                <div className={'alert alert-danger'}>{numberError}</div>
                                            }
                                        </div>
                                    </div>
                                </h6>
                            </CardHeader>
                            {pending && pending.length > 0 ?
                                <CardBody className="p-0 pb-3 table-responsive">
                                    <table className="table  mb-0">
                                        <thead className="lightblue-bg">
                                            <tr>
                                                <th className="border-0"> #</th>
                                                <th className="border-0">Number</th>
                                                <th className="border-0">Invited at</th>
                                                <th className="border-0 ">Status</th>
                                                <th className="border-0 text-center">Remove </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pending.map((invite, i) =>
                                                (<tr key={invite._id}>
                                                    <td>{i + 1}</td>
                                                    <td>{invite.number}</td>
                                                    <td>{moment(invite.createAt).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                    <td>{invite.status}</td>
                                                    <td className="th-fa-icons text-center"><i className="fa fa-trash-o" aria-hidden="true" onClick={this.handleRemoveInvite.bind(this, invite._id)}></i></td>
                                                </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </CardBody>
                                : null}
                        </Card>


                        <Card className="mb-4 card-custom">
                            <CardHeader className="border-bottom card-header-custom">
                                <h6 className="m-0">
                                    Extensions
                                </h6>
                            </CardHeader>
                            <CardBody className="p-0 pb-3 table-responsive">
                                <table className="table  mb-0">
                                    <thead className="lightBlue-bg">
                                        <tr>
                                            <th className="border-0"> # </th>
                                            <th className="border-0">Name</th>
                                            <th className="border-0">Mobile Number </th>
                                            <th className="border-0 ">Status</th>
                                            {id ? <th className="border-0 text-center">View </th> : null}
                                            {id ? <th className="border-0 text-center">Deactivate </th> : null}
                                            {id ? <th className="border-0 text-center">Remove </th> : null}

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {extensions.map((extension, i) =>
                                            (<tr key={extension._id}>
                                                <td>{i + 1}</td>
                                                {editingExtensionId === extension._id ?
                                                    <td>
                                                        <Row>
                                                            <Col xs="8" sm="10">
                                                                <input
                                                                    type="text"
                                                                    className="form-control pull-left"
                                                                    name="name"
                                                                    id="name"
                                                                    value={editingExtensionName}
                                                                    onChange={this.handleExtensionNameChange}
                                                                />
                                                            </Col>
                                                            <Col xs="4" sm="2">
                                                                <button className="btn btn-lightblue pull-left" onClick={this.changeExtensionName}>Save</button>
                                                            </Col>
                                                        </Row>
                                                    </td> :
                                                    <td>{extension.name} <i className="fa fa-pencil-square-o "
                                                        aria-hidden="true"
                                                        onClick={this.editExtensionName.bind(this, extension)}></i>
                                                    </td>
                                                }
                                                <td>{extension.accountNumber}</td>
                                                {this.showExtensionStatus(extension)}
                                                {id ? <td className="th-fa-icons text-center"><i className="fa fa-eye" aria-hidden="true" onClick={this.handleShowModalExtension.bind(this, extension)}></i></td> : null}
                                                {id ? <td className="th-fa-icons text-center"><i className="fa fa-ban" aria-hidden="true" onClick={this.handleDeactivateExtension.bind(this, extension._id)}></i></td> : null}
                                                {id ? <td className="th-fa-icons text-center"><i className="fa fa-trash-o" aria-hidden="true" onClick={this.handleRemoveExtension.bind(this, extension._id)}></i></td> : null}
                                            </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>

                    </div>
                    {/* : null} */}
                </div>
            </div>
        )
    }
}

Extensions.propTypes = {

}



// WEBPACK FOOTER //
// ./src/components/extensionsComponent/extensions.js